<template>
  
  <div>
    <dx-popup style="padding:0px;"
      :width="380"
      :height="220"
      :show-title="false"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :visible.sync = "isShown"
      :on-hiding = "closeform"
    >

    <v-container  grid-list-xl pt-0 style="padding:0px;">
			<app-card>

     <v-layout row wrap>
        <v-flex sm12>
        <dx-button text="Afspraak opmaken" @click="btnAppoint" />
        </v-flex>
        <v-flex sm12>
        <dx-button text="Afspraak opmaken via zoeken" @click="btnAppoint" />
        </v-flex>
        <v-flex sm12>
        <dx-button text="Notitie opmaken" @click="btnNote" />
        </v-flex>
     </v-layout>
			</app-card>
    </v-container>

    </dx-popup>

    <AppointFormNote ref="appNoteFrm"></AppointFormNote>
    <AppointFormAppoint ref="appAppointFrm"></AppointFormAppoint>

  </div>

</template>

<style>
.dx-popup-content {
    padding: 0px;
}
.container {
  padding: 0px;
}
</style>

<script>

import { DxButton, DxPopup, DxPopover } from 'devextreme-vue';

import AppointFormNote from "./AppointFormNote";
import AppointFormAppoint from "./AppointFormAppoint";

export default {
  components: {
    DxButton, DxPopup, DxPopover, AppointFormNote, AppointFormAppoint
  },
   props: {
  },
  data: function() {
    return {
      showForm : false,
      position: {
        offset: '0, 2',
        at: 'bottom',
        my: 'top',
        collision: 'fit flip'
      }
    };
  },
 mounted() {
     this.showForm = false;
  },
  computed: {
     isShown () {
         return this.showForm;
     }
  },
  methods: {
      closeform () {
          console.log ("Closing form");
          this.showForm = false;
      },
      show (item) {
          console.log ("Show form");
           if (item == undefined)
           {
               this.showForm = true;
           }
           else
           {
               this.showForm = false;
               if (item.appointmentData.itemobject.KindAppoint < 10000)
               {
                   this.btnAppoint (item);
               }
               else
               {
                   this.btnNote (item);
               }
           }
          
      },
      btnAppoint (item) {
          console.log ("afspraak klik");
          this.closeform ();
          this.$refs.appAppointFrm.show(item);
      },
      btnNote (item) {
          console.log ("notitie klik");
          this.closeform ();
          this.$refs.appNoteFrm.show (item);
      }
  }
};
</script>